export default __webpack_public_path__ + "static/media/place-5.f2c538c0.jpg";